export function isValidQuantityInput(value: string) {
  const normalized = value.trim();
  return /^\d+(\.\d+)?$/.test(normalized);
}

export function normalizeCentavosValue(value: number | string | null): string | null {
  if (value === null) {
    return null;
  }

  const parsed =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number(value.trim())
        : NaN;
  if (!Number.isFinite(parsed) || !Number.isInteger(parsed)) {
    return null;
  }

  const normalized = String(parsed);
  const isNegative = normalized.startsWith('-');
  const abs = isNegative ? normalized.slice(1) : normalized;
  const compactAbs = abs.replace(/^0+(?=\d)/, '');

  return `${isNegative ? '-' : ''}${compactAbs}`;
}

export function centavosToPesoInput(value: number | string | null): string {
  const normalized = normalizeCentavosValue(value);
  if (!normalized) {
    return '';
  }

  const isNegative = normalized.startsWith('-');
  const abs = isNegative ? normalized.slice(1) : normalized;
  const padded = abs.padStart(3, '0');
  const pesos = padded.slice(0, -2).replace(/^0+(?=\d)/, '');
  const centavos = padded.slice(-2);

  return `${isNegative ? '-' : ''}${pesos}.${centavos}`;
}

export function parsePesoInputToCentavos(value: string): number | null {
  const normalized = value.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
    return null;
  }

  const [wholePart = '0', centsPart = ''] = normalized.split('.');
  const compactWhole = wholePart.replace(/^0+(?=\d)/, '');
  const compactCents = centsPart.padEnd(2, '0');

  const parsed = Number(`${compactWhole}${compactCents}`.replace(/^0+(?=\d)/, ''));
  if (!Number.isFinite(parsed)) {
    return null;
  }

  return parsed;
}
